(ns client-portal.client.oasys.sessions.views
  (:require [clojure.string :as s]
            [client-portal.client.layout :as l]
            [client-portal.client.oasys.sessions.data :as oasys.sessions.d]
            [client-portal.client.oasys.sessions.drawer.views :as oasys.drawer]
            [client-portal.client.oasys.sessions.filters.views :as oasys.filters]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.voice-insights.sessions.data :as vi.sessions.d]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as t]
            [shared.core.util :as util]))

(defn sessions-header []
  (let [container-id "oasys-sessions-header-container"
        count- (re/subscribe [:oasys/sessions-count-])
        admin?- (re/subscribe [:account/admin-role?-])
        vs- (re/subscribe [:core/viewport-size])
        applied-filters- (re/subscribe [:oasys-filters/applied-filters-])
        set-header-height #(when-let [h (some-> (js/document.getElementById container-id)
                                                (.getBoundingClientRect)
                                                (.-height))]
                             (re/dispatch [:oasys/set-header-height h]))]
    (re/create-class
      {:component-did-mount set-header-height
       :component-did-update set-header-height
       :reagent-render
       (fn []
         @vs- @applied-filters-
         [:div {:id container-id
                :style {:background-color (style/alc-color "Background/card_hex")
                        :display :flex
                        :flex-direction :column
                        :gap 16
                        :padding "12px 16px 16px"
                        :position :sticky
                        :top 0
                        :z-index (inc (style/z :medium))}}
          [:div {:style {:display :flex
                         :flex-wrap :wrap
                         :align-items :center
                         :justify-content :space-between
                         :gap 16}}
           [:span {:style {:color (style/alc-color "Text/primary_header")
                           :font-size 24
                           :line-height 1.33}}
            "Sessions"
            (when-not (util/loading? @count-)
              [:span {:style {:color (style/alc-color "Text/primary")
                              :margin-left 8}}
               (str "(" (some-> @count- (util/readable-number)) ")")])]
           [:div {:style {:display :flex
                          :align-items :center
                          :gap 8}}
            [oasys.filters/filter-button]
            (when @admin?-
              (let [search (fn [e]
                             (when-let [el (js/document.getElementById "oasys-convo-id-search-input")]
                               (let [v (or (some-> e (.-clipboardData) (.getData "text/plain"))
                                           (.-value el))]
                                 (when (not-empty v)
                                   (re/dispatch [:oasys/toggle-session-panel {:conversation-id (s/trim v)
                                                                              :open? true}]))
                                 (set! (.-value el) "")
                                 (.blur el))))]
                [alc/up-input {:id :oasys-convo-id-search-input
                               :class-name "w-60"
                               :placeholder "Search By Session ID"
                               :on-key-down #(when (util/enter-key-event? %)
                                               (search %))
                               :on-paste search}]))]]
          [oasys.filters/applied-filter-pills]])})))

(defn sessions-list []
  (let [sessions- (re/subscribe [:oasys/sessions-flattened-])
        loading?- (re/subscribe [:oasys/sessions-list-loading?-])
        has-more?- (re/subscribe [:oasys/sessions-has-more?-])
        next-page-loading?- (re/subscribe [:oasys/sessions-next-page-loading?-])
        next-page- (re/subscribe [:oasys/sessions-next-page-])
        admin?- (re/subscribe [:account/admin-role?-])
        selected- (re/subscribe [:oasys/selected-session-])
        header-height- (re/subscribe [:oasys/header-height-])]
    (fn []
      (let [admin? @admin?-
            selected-id (:conversation-id @selected-)
            selected-style {:background-color (style/alc-color "Background/active_secondary")}]
        [alc/table {:no-data-text "No sessions to display"
                    :loading? @loading?-
                    :loading-more? @next-page-loading?-
                    :scroll-container-id l/core-scroll-content-id
                    :bottom-px-buffer 200
                    :on-bottom-buffer (when @has-more?-
                                        #(re/dispatch [:oasys/load-sessions [nil {:page @next-page-}]]))
                    :has-more-rows? true
                    :sticky-headers? true
                    :expanded-form-path oasys.sessions.d/table-columns-path
                    :header-top @header-height-
                    :row-style {:height :auto
                                :align-items :flex-start}
                    :flex-vals (filterv identity
                                        [(when admin? "0 0 130px")
                                         "0 0 120px"
                                         "0 0 140px"
                                         "0 0 70px"
                                         "0 0 80px"
                                         "0 0 88px"
                                         "1 0 200px"
                                         "1 0 180px"
                                         (when admin? "1 0 240px")])
                    :sticky-header-x-scroll? true
                    :headers (filterv identity
                                      [(when admin? "Session ID")
                                       "Timestamp"
                                       "Channel"
                                       "Duration"
                                       "Messages"
                                       {:column-id "resolution"
                                        :label "Resolution"
                                        :expandable? true
                                        :expanded-flex-val "0 0 160px"}
                                       "Topics"
                                       "Intents"
                                       (when admin? "Metrics")])
                    :rows (map-indexed
                            (fn [idx {:keys [conversation-id conversation-date conversation-ts channel duration resolution-status
                                             escalated topics intents metrics] :as session}]
                              {:cells (filterv identity
                                               [(when admin?
                                                  {:label conversation-id
                                                   :copyable? true
                                                   :style {:color (style/alc-color "Text/secondary")
                                                           :white-space :nowrap}})
                                                {:label [:span {:style {:color (style/alc-color "Text/secondary")}}
                                                         conversation-ts]}
                                                {:label (or channel "-")}
                                                {:label (some-> duration (t/seconds->format))}
                                                {:label (str (oasys.sessions.d/message-count session))}
                                                {:label [oasys.drawer/resolution-icon {:resolution-status resolution-status}]
                                                 :expanded-content [oasys.drawer/resolution-label {:resolution-status resolution-status}]}
                                                {:label (into [:div {:style {:display :flex
                                                                             :flex-wrap :wrap
                                                                             :gap 8}}]
                                                              (concat (when escalated
                                                                        [[tag/conversation-tag-pill {:name "escalation"
                                                                                                     :value "Escalated"
                                                                                                     :hide-name? true}]])
                                                                      (mapv (fn [{:keys [name resolution-status]}]
                                                                              [tag/utterance-tag-pill
                                                                               (cond-> {:name "topic"
                                                                                        :value name
                                                                                        :hide-name? true}
                                                                                       resolution-status
                                                                                       (assoc :icon-type (:icon-type (oasys.sessions.d/resolution-style resolution-status))
                                                                                              :children [{:name "resolution"
                                                                                                          :value resolution-status}]
                                                                                              :show-description? true
                                                                                              :hide-children-header? true))])
                                                                            topics)))
                                                 :style {:flex-wrap :wrap
                                                         :padding "0 12px"}}
                                                {:label (into [:div {:style {:display :flex
                                                                             :flex-wrap :wrap
                                                                             :gap 8}}]
                                                              (map #(vector oasys.drawer/value-pill {:value (tag/intent-name->display-name %)
                                                                                                     :color tag.d/blue-tag-color}))
                                                              intents)
                                                 :style {:flex-wrap :wrap
                                                         :padding "0 12px"}}
                                                (when admin?
                                                  {:label (into [:div {:style {:display :flex
                                                                               :flex-wrap :wrap
                                                                               :gap 8}}]
                                                                (comp (map (fn [{:keys [code value]}]
                                                                             {:label (tag/metric-code->display-name code)
                                                                              :value value
                                                                              :color tag.d/purple-tag-color}))
                                                                      (distinct)
                                                                      (map #(vector oasys.drawer/value-pill %)))
                                                                metrics)
                                                   :style {:flex-wrap :wrap
                                                           :padding "0 12px"}})])
                               :on-click #(re/dispatch [:oasys/toggle-session-panel {:conversation-id conversation-id
                                                                                     :conversation-date conversation-date
                                                                                     :conversation-ts conversation-ts
                                                                                     :convo-idx idx}])
                               :hover-style (when (= selected-id conversation-id) selected-style)
                               :style (when (= selected-id conversation-id) selected-style)})
                            @sessions-)}]))))

(defn root [_]
  (let [sessions- (re/subscribe [:oasys/sessions-flattened-])
        loading?- (re/subscribe [:oasys/sessions-list-loading?-])
        selected- (re/subscribe [:oasys/selected-session-])
        active-panel- (re/subscribe [:layout/active-panel-right-])
        open-session-from-conv (fn [this prev-conv-qp]
                                 (if-let [conv (some-> (:conv (re/props this))
                                                       (vi.sessions.d/conv-qp->conversation)
                                                       (util/->kebab-case-keywords))]
                                   (when-not (and (= (first @active-panel-) oasys.sessions.d/panel-key)
                                                  (= (:conversation-id conv) (:conversation-id @selected-)))
                                     (re/dispatch [:oasys/toggle-session-panel (assoc conv :open? true)]))
                                   ;; The header drops `conv` on a concept change, as does going back.
                                   (when (and prev-conv-qp (not= prev-conv-qp (:conv (re/props this))))
                                     (re/dispatch [:oasys/clear-selected-session]))))]
    (re/create-class
      {:component-did-mount (fn [this]
                              (re/dispatch [:oasys/sessions-initialize])
                              (open-session-from-conv this nil))
       :component-did-update (fn [this [_ prev-args]]
                               (open-session-from-conv this (:conv prev-args)))
       :component-will-unmount #(re/dispatch [:layout/hide-panel-right])
       :reagent-render
       (fn [args]
         [l/logged-in-with-header-nav-oasys
          (merge args {:concept-dropdown? true
                       :location-dropdown? false})
          [:div {:style {:display :flex
                         :flex-direction :column
                         :width "100%"
                         :min-height "100%"}}
           [sessions-header]
           [:div {:style {:flex 1
                          :display :flex
                          :flex-direction :column
                          :padding "0 16px 12px"}}
            (cond
              @loading?- [empty-state/loading-sessions-card]
              (empty? @sessions-) [empty-state/no-sessions-card]
              :else [sessions-list])]]])})))
